import { IconButton } from "@mui/joy";
import { Bell } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

export function ProfileButtonNotifications() {
    const navigate = useNavigate();

    return (
        <IconButton
            variant="soft"
            color="primary"
            onClick={() => navigate('/notifications')}
            sx={(theme) => ({
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '2px',
                px: 2,
                py: 1,
                borderRadius: "999px",
                width: '56px',
                color: theme.palette.mode === 'dark'
                    ? theme.palette.primary[100]
                    : null,
                fontSize: '12px',
                '& svg': {
                    width: '24px',
                    height: '24px',
                }
            })}
        >
            <Bell size={24} />
        </IconButton>
    )
}
